<template>
    <div style="display: flex;justify-content: space-between;margin: 20px">
        <div>
            <el-button type="primary" :disabled="loading" @click="openDialog()">新建实验</el-button>
            <el-button type="success" :disabled="loading" @click="openTestDialog">测试请求</el-button>
        </div>
        <el-switch v-model="domain" inactive-text="测试环境" active-text="正式环境" inactive-value="elastic-test"
                   active-value="elastic" @change="$router.push({query: {domain}})"></el-switch>
    </div>
    <el-table :data="data" v-loading="loading">
        <el-table-column label="实验名称" width="150" prop="name"></el-table-column>
        <el-table-column label="基础Tag" width="120" prop="tag">
            <template #default="scope">
                <span class="sdk-tag">{{ getBaseTag(scope.row) }}</span>
            </template>
        </el-table-column>
        <el-table-column label="启用" width="100" prop="active">
            <template #default="scope">
                <el-switch v-model="scope.row.active" :disabled="loading" @change="update(scope.row)"></el-switch>
            </template>
        </el-table-column>
        <el-table-column label="最小版本" width="100" prop="app_version"></el-table-column>
        <el-table-column label="国家" width="150" prop="country" show-overflow-tooltip>
            <template #default="scope">
                {{ scope.row.country.join('、') || '全球' }}
            </template>
        </el-table-column>
        <el-table-column label="流量" width="100" prop="percent">
            <template #default="scope">{{ scope.row.percent }}%</template>
        </el-table-column>
        <el-table-column label="实验组" width="100" prop="data">
            <template #default="scope">
                {{ scope.row.data.length }}
            </template>
        </el-table-column>
        <el-table-column label="操作" width="260">
            <template #default="scope">
                <el-button type="primary" :disabled="loading" @click="cloneExp(scope.row)">复制</el-button>
                <el-button type="success" :disabled="loading" @click="openDialog(scope.row)">编辑</el-button>
                <el-button type="danger" :disabled="loading" @click="remove(scope.row)">删除</el-button>
            </template>
        </el-table-column>
    </el-table>
    <el-dialog v-model="dialog_opened">
        <el-form :model="form" ref="form" label-width="100px">
            <div v-show="step===0">
                <el-form-item label="实验名称" prop="name" :rules="[{required: true, message: '请输入实验名称'}]">
                    <el-input v-model="form.name" :disabled="loading"></el-input>
                </el-form-item>
                <el-form-item label="流量占比" prop="percent">
                    <el-slider :disabled="loading" v-model="form.percent" :max="100" :min="1"
                               :marks="marks"></el-slider>
                </el-form-item>
                <el-form-item label="最小版本" prop="app_version"
                              :rules="[{required: true, message: '请选择最小版本'}, {validator: versionValidator}]">
                    <el-select v-model="form.app_version" filterable allow-create style="width: 300px">
                        <el-option :disabled="loading" v-for="v in version_list" :key="v.id"
                                   :value="v.version"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="生命周期" prop="living_days"
                              :rules="[{required: true, message: '请输入最小生命周期'}, {type: 'number', message: '必须是自然数'}]">
                    <el-input-number :disabled="loading" v-model="form.living_days" :min="0"></el-input-number>
                </el-form-item>
                <el-form-item label="国家" prop="country">
                    <country-selector v-model="form.country"></country-selector>
                </el-form-item>
            </div>
            <div v-show="step===1">
                <el-table :data="form.data">
                    <el-table-column label="实验组" width="100">
                        <template #default="scope">
                            {{ scope.$index ? `实验组${scope.$index}` : '对照组' }}
                        </template>
                    </el-table-column>
                    <el-table-column label="上报Tag" width="120">
                        <template #default="scope">
                            <span class="sdk-tag">{{ getGroupTag(form, scope.$index) }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="包含广告组" width="100">
                        <template #default="scope">
                            {{ scope.row._count_groups }}个
                        </template>
                    </el-table-column>
                    <el-table-column label="包含广告位" width="100">
                        <template #default="scope">
                            {{ scope.row._count_placement }}个
                        </template>
                    </el-table-column>
                    <el-table-column label="包含聚合平台" width="120">
                        <template #default="scope">
                            {{ scope.row._count_mediation }}个
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="150">
                        <template #default="scope">
                            <el-button size="small" type="success" @click="$refs.expGroup.edit(scope.row)"
                                       :disabled="loading">编辑
                            </el-button>
                            <el-button size="small" type="danger" @click="removeExpGroup(scope.row)"
                                       :disabled="loading">删除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <el-button type="success" @click="addExpGroup" :disabled="loading">添加实验组</el-button>
            </div>
        </el-form>
        <template #footer>
            <el-button :loading="loading" @click="reset">取消</el-button>
            <el-button type="primary" :loading="loading" @click="next" v-if="step===0">下一步</el-button>
            <el-button type="primary" :loading="loading" @click="submit" v-else-if="step===1">确定</el-button>
        </template>
    </el-dialog>
    <el-dialog v-model="test_dialog_opened" title="模拟 SDK 拉配置" width="800px">
        <el-form :model="test_form" ref="testForm" label-width="100px">
            <el-form-item label="用户 ID" prop="userId" :rules="[{required: true, message: '请输入用户 ID'}]">
                <el-input v-model="test_form.userId" :disabled="test_loading"></el-input>
            </el-form-item>
            <el-form-item label="App 版本" prop="appVersion"
                          :rules="[{required: true, message: '请输入 App 版本'}, {validator: versionValidator}]">
                <el-select v-model="test_form.appVersion" filterable allow-create style="width: 300px"
                           :disabled="test_loading">
                    <el-option v-for="v in version_list" :key="v.id || v.version" :value="v.version"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="国家" prop="country" :rules="[{required: true, message: '请输入国家'}]">
                <el-input v-model="test_form.country" :disabled="test_loading" placeholder="例如 US"></el-input>
            </el-form-item>
            <el-form-item label="生命周期" prop="day"
                          :rules="[{required: true, message: '请输入生命周期'}, {type: 'number', message: '必须是自然数'}]">
                <el-input-number v-model="test_form.day" :min="0" :disabled="test_loading"></el-input-number>
            </el-form-item>
        </el-form>
        <json-input v-if="test_result" v-model="test_result" mode="code" height="420px"
                    v-loading="test_loading"></json-input>
        <template #footer>
            <el-button @click="test_dialog_opened=false" :disabled="test_loading">关闭</el-button>
            <el-button @click="copyTestResult" :disabled="!test_result || test_loading">复制 JSON</el-button>
            <el-button type="primary" @click="testRequest" :loading="test_loading">发送请求</el-button>
        </template>
    </el-dialog>
    <sdk-exp-group ref="expGroup"></sdk-exp-group>
</template>

<script>
import axios from 'ts-axios-new';
import {update, versionValidator} from "../../libs/utils";
import CountrySelector from "../../base/CountrySelector";
import JsonInput from "../../base/JsonInput";
import SdkExpGroup from "./SdkExpGroup";
import {ElMessage, ElMessageBox} from 'element-plus'

function md5(input) {
    function rotateLeft(value, amount) {
        return (value << amount) | (value >>> (32 - amount));
    }

    function addUnsigned(x, y) {
        return (x + y) >>> 0;
    }

    function cmn(q, a, b, x, s, t) {
        return addUnsigned(rotateLeft(addUnsigned(addUnsigned(a, q), addUnsigned(x, t)), s), b);
    }

    function ff(a, b, c, d, x, s, t) {
        return cmn((b & c) | ((~b) & d), a, b, x, s, t);
    }

    function gg(a, b, c, d, x, s, t) {
        return cmn((b & d) | (c & (~d)), a, b, x, s, t);
    }

    function hh(a, b, c, d, x, s, t) {
        return cmn(b ^ c ^ d, a, b, x, s, t);
    }

    function ii(a, b, c, d, x, s, t) {
        return cmn(c ^ (b | (~d)), a, b, x, s, t);
    }

    function utf8Bytes(str) {
        return unescape(encodeURIComponent(str));
    }

    function toWords(str) {
        const length = str.length;
        const words = Array(((((length + 8) >> 6) + 1) * 16)).fill(0);
        let i;
        for (i = 0; i < length; i += 1) {
            words[i >> 2] |= str.charCodeAt(i) << ((i % 4) * 8);
        }
        words[length >> 2] |= 0x80 << ((length % 4) * 8);
        words[(((length + 8) >> 6) * 16) + 14] = length * 8;
        return words;
    }

    function wordToHex(value) {
        let hex = '';
        for (let i = 0; i <= 3; i += 1) {
            hex += (`0${((value >>> (i * 8)) & 255).toString(16)}`).slice(-2);
        }
        return hex;
    }

    const x = toWords(utf8Bytes(input));
    let a = 0x67452301;
    let b = 0xefcdab89;
    let c = 0x98badcfe;
    let d = 0x10325476;

    for (let k = 0; k < x.length; k += 16) {
        const aa = a;
        const bb = b;
        const cc = c;
        const dd = d;

        a = ff(a, b, c, d, x[k + 0], 7, 0xd76aa478);
        d = ff(d, a, b, c, x[k + 1], 12, 0xe8c7b756);
        c = ff(c, d, a, b, x[k + 2], 17, 0x242070db);
        b = ff(b, c, d, a, x[k + 3], 22, 0xc1bdceee);
        a = ff(a, b, c, d, x[k + 4], 7, 0xf57c0faf);
        d = ff(d, a, b, c, x[k + 5], 12, 0x4787c62a);
        c = ff(c, d, a, b, x[k + 6], 17, 0xa8304613);
        b = ff(b, c, d, a, x[k + 7], 22, 0xfd469501);
        a = ff(a, b, c, d, x[k + 8], 7, 0x698098d8);
        d = ff(d, a, b, c, x[k + 9], 12, 0x8b44f7af);
        c = ff(c, d, a, b, x[k + 10], 17, 0xffff5bb1);
        b = ff(b, c, d, a, x[k + 11], 22, 0x895cd7be);
        a = ff(a, b, c, d, x[k + 12], 7, 0x6b901122);
        d = ff(d, a, b, c, x[k + 13], 12, 0xfd987193);
        c = ff(c, d, a, b, x[k + 14], 17, 0xa679438e);
        b = ff(b, c, d, a, x[k + 15], 22, 0x49b40821);

        a = gg(a, b, c, d, x[k + 1], 5, 0xf61e2562);
        d = gg(d, a, b, c, x[k + 6], 9, 0xc040b340);
        c = gg(c, d, a, b, x[k + 11], 14, 0x265e5a51);
        b = gg(b, c, d, a, x[k + 0], 20, 0xe9b6c7aa);
        a = gg(a, b, c, d, x[k + 5], 5, 0xd62f105d);
        d = gg(d, a, b, c, x[k + 10], 9, 0x02441453);
        c = gg(c, d, a, b, x[k + 15], 14, 0xd8a1e681);
        b = gg(b, c, d, a, x[k + 4], 20, 0xe7d3fbc8);
        a = gg(a, b, c, d, x[k + 9], 5, 0x21e1cde6);
        d = gg(d, a, b, c, x[k + 14], 9, 0xc33707d6);
        c = gg(c, d, a, b, x[k + 3], 14, 0xf4d50d87);
        b = gg(b, c, d, a, x[k + 8], 20, 0x455a14ed);
        a = gg(a, b, c, d, x[k + 13], 5, 0xa9e3e905);
        d = gg(d, a, b, c, x[k + 2], 9, 0xfcefa3f8);
        c = gg(c, d, a, b, x[k + 7], 14, 0x676f02d9);
        b = gg(b, c, d, a, x[k + 12], 20, 0x8d2a4c8a);

        a = hh(a, b, c, d, x[k + 5], 4, 0xfffa3942);
        d = hh(d, a, b, c, x[k + 8], 11, 0x8771f681);
        c = hh(c, d, a, b, x[k + 11], 16, 0x6d9d6122);
        b = hh(b, c, d, a, x[k + 14], 23, 0xfde5380c);
        a = hh(a, b, c, d, x[k + 1], 4, 0xa4beea44);
        d = hh(d, a, b, c, x[k + 4], 11, 0x4bdecfa9);
        c = hh(c, d, a, b, x[k + 7], 16, 0xf6bb4b60);
        b = hh(b, c, d, a, x[k + 10], 23, 0xbebfbc70);
        a = hh(a, b, c, d, x[k + 13], 4, 0x289b7ec6);
        d = hh(d, a, b, c, x[k + 0], 11, 0xeaa127fa);
        c = hh(c, d, a, b, x[k + 3], 16, 0xd4ef3085);
        b = hh(b, c, d, a, x[k + 6], 23, 0x04881d05);
        a = hh(a, b, c, d, x[k + 9], 4, 0xd9d4d039);
        d = hh(d, a, b, c, x[k + 12], 11, 0xe6db99e5);
        c = hh(c, d, a, b, x[k + 15], 16, 0x1fa27cf8);
        b = hh(b, c, d, a, x[k + 2], 23, 0xc4ac5665);

        a = ii(a, b, c, d, x[k + 0], 6, 0xf4292244);
        d = ii(d, a, b, c, x[k + 7], 10, 0x432aff97);
        c = ii(c, d, a, b, x[k + 14], 15, 0xab9423a7);
        b = ii(b, c, d, a, x[k + 5], 21, 0xfc93a039);
        a = ii(a, b, c, d, x[k + 12], 6, 0x655b59c3);
        d = ii(d, a, b, c, x[k + 3], 10, 0x8f0ccc92);
        c = ii(c, d, a, b, x[k + 10], 15, 0xffeff47d);
        b = ii(b, c, d, a, x[k + 1], 21, 0x85845dd1);
        a = ii(a, b, c, d, x[k + 8], 6, 0x6fa87e4f);
        d = ii(d, a, b, c, x[k + 15], 10, 0xfe2ce6e0);
        c = ii(c, d, a, b, x[k + 6], 15, 0xa3014314);
        b = ii(b, c, d, a, x[k + 13], 21, 0x4e0811a1);
        a = ii(a, b, c, d, x[k + 4], 6, 0xf7537e82);
        d = ii(d, a, b, c, x[k + 11], 10, 0xbd3af235);
        c = ii(c, d, a, b, x[k + 2], 15, 0x2ad7d2bb);
        b = ii(b, c, d, a, x[k + 9], 21, 0xeb86d391);

        a = addUnsigned(a, aa);
        b = addUnsigned(b, bb);
        c = addUnsigned(c, cc);
        d = addUnsigned(d, dd);
    }

    return `${wordToHex(a)}${wordToHex(b)}${wordToHex(c)}${wordToHex(d)}`;
}

function md5TailMod(input, divisor) {
    return Number(BigInt(`0x${md5(input).slice(-16)}`) % BigInt(divisor));
}

function getVersionNumber(appVersion) {
    const nums = appVersion.split('.');
    if (nums.length > 3 || nums.some(num => num.length > 3)) {
        throw new Error('version error');
    }
    while (nums.length < 3) {
        nums.push('0');
    }
    return nums.map(num => (`000${parseInt(num || '0')}`).slice(-3)).join('');
}

export default {
    name: "Sdk",
    components: {JsonInput, SdkExpGroup, CountrySelector},
    data() {
        return {
            loading: false, data: [], dialog_opened: false, editing: null, version_list: [], step: 0,
            test_loading: false, test_dialog_opened: false, test_result: null,
            marks: {10: '10%', 30: '30%', 50: '50%', 70: '70%', 90: '90%'},
            domain: this.$route.query.domain || 'elastic-test', mediation_list: ['Max'],
            test_form: {
                userId: 'test_user',
                appVersion: '',
                country: 'US',
                day: 0,
            },
            form: {
                product_id: this.$route.params.productId,
                name: '',
                percent: 100,
                app_version: '',
                living_days: 0,
                country: [],
                data: [],
                active: false,
            },
        }
    },
    methods: {
        getBaseTag(row) {
            return row && row.tag ? row.tag : '保存后生成';
        },
        getGroupTag(row, index) {
            if (!row || !row.tag) {
                return '保存后生成';
            }
            return `${row.tag}${index}`;
        },
        init() {
            this.loading = true;
            axios.all([
                axios.get(`${this.$root.$getElasticDomain()}/cms/v1/mediation`, {params: {product_id: this.$route.params.productId}}).then(res => {
                    this.data = res.data.data.mediationList;
                    this.loading = false;
                }), axios.get('/api/v1/pm/version', {params: {product_id: this.$route.params.productId}}).then(res => {
                    update(this.version_list, res.data.data.versionList.filter(row => row['version'] && row['version'].length > 1));
                }),
            ])
        },
        openDialog(item) {
            this.dialog_opened = true;
            this.step = 0;
            this.$nextTick(_ => {
                if (item) {
                    this.editing = item;
                    update(this.form, item);
                }
            })
        },
        cloneExp(row) {
            ElMessageBox.prompt('请输入新实验名称', '复制实验', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                inputValue: `${row.name} (副本)`,
                inputPattern: /\S+/,
                inputErrorMessage: '实验名称不能为空',
            }).then(({value}) => {
                this.loading = true;
                const payload = JSON.parse(JSON.stringify(row));
                ['id', 'tag', 'version_num', 'count_country', 'created_at', 'updated_at'].forEach(key => {
                    delete payload[key];
                });
                payload.name = value.trim();
                payload.active = false;
                payload.product_id = this.$route.params.productId;
                axios.post(`${this.$root.$getElasticDomain()}/cms/v1/mediation`, payload).then(res => {
                    this.data.unshift(res.data.data);
                    this.loading = false;
                    ElMessage.success('复制成功');
                }).catch(err => {
                    this.loading = false;
                    ElMessage.error(err.response?.data?.message || '复制失败');
                });
            }).catch(_ => {
            });
        },
        reset() {
            this.loading = this.dialog_opened = false;
            this.editing = null;
            this.$refs.form.resetFields();
            this.form.data = [];
            this.form.country = [];
            this.step = 0;
        },
        versionValidator(rules, value, callback) {
            return versionValidator(rules, value, callback)
        },
        openTestDialog() {
            this.test_dialog_opened = true;
            if (!this.test_form.appVersion && this.version_list.length) {
                this.test_form.appVersion = this.version_list[0].version;
            }
        },
        testRequest() {
            this.$refs.testForm.validate(valid => {
                if (!valid) {
                    return;
                }
                this.test_loading = true;
                this.test_result = null;
                axios.get(`${this.$root.$getElasticDomain()}/cms/v1/mediation`, {
                    params: {product_id: this.$route.params.productId},
                }).then(res => {
                    this.test_result = this.simulateSdkResult(res.data.data.mediationList || []);
                }).catch(err => {
                    this.test_result = err.response ? err.response.data : {
                        message: err.message || '请求失败',
                    };
                    ElMessage.error('测试请求失败，已展示错误返回');
                }).finally(_ => {
                    this.test_loading = false;
                });
            })
        },
        simulateSdkResult(mediationList) {
            const versionNum = getVersionNumber(this.test_form.appVersion);
            const sortedList = mediationList.filter(row => row.active).sort((a, b) => {
                const versionA = a.version_num || getVersionNumber(a.app_version);
                const versionB = b.version_num || getVersionNumber(b.app_version);
                if (versionA !== versionB) {
                    return versionA > versionB ? -1 : 1;
                }
                const countryA = a.count_country || ((a.country || []).length || 999);
                const countryB = b.count_country || ((b.country || []).length || 999);
                if (countryA !== countryB) {
                    return countryA - countryB;
                }
                return b.living_days - a.living_days;
            });
            for (const row of sortedList) {
                const rowVersionNum = row.version_num || getVersionNumber(row.app_version);
                const country = row.country || [];
                const data = row.data || [];
                const countryMatched = !country.length || country.includes(this.test_form.country);
                const bucket = md5TailMod(`${row.id}${this.test_form.userId}`, 100);
                if (versionNum >= rowVersionNum
                    && countryMatched
                    && this.test_form.day >= row.living_days
                    && bucket < row.percent) {
                    if (data.length) {
                        const index = md5TailMod(this.test_form.userId, data.length);
                        return {
                            groups: data[index].groups,
                            mediations: data[index].mediations,
                            tag: `${row.tag}${index}`,
                        };
                    }
                    break;
                }
            }
            return {groups: [], mediations: [], tag: null};
        },
        copyTestResult() {
            if (!this.test_result) {
                return;
            }
            navigator.clipboard.writeText(JSON.stringify(this.test_result, null, 2)).then(_ => {
                ElMessage.success('JSON 已复制');
            }).catch(_ => {
                ElMessage.error('复制失败');
            });
        },
        next() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.step = 1;
                }
            })
        },
        submit() {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.loading = true;
                    if (this.editing) {
                        axios.put(`${this.$root.$getElasticDomain()}/cms/v1/mediation/${this.editing.id}`, this.form).then(res => {
                            update(this.editing, res.data.data);
                            this.reset();
                        })
                    } else {
                        axios.post(`${this.$root.$getElasticDomain()}/cms/v1/mediation`, this.form).then(res => {
                            this.data.unshift(res.data.data);
                            this.reset();
                        })
                    }
                }
            })
        },
        update(row) {
            this.loading = true;
            axios.put(`${this.$root.$getElasticDomain()}/cms/v1/mediation/${row.id}`, row).then(_ => {
                this.loading = false;
            })
        },
        addExpGroup() {
            const exp = {
                mediations: [], groups: [],
                _count_placement: 0, _count_mediation: 0, _count_groups: 0,
            };
            this.form.data.push(exp);
            this.$refs.expGroup.edit(exp);
        },
        removeExpGroup(row) {
            ElMessageBox.confirm('确定要删除该实验组吗？', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'warning'
            }).then(_ => {
                this.form.data.splice(this.form.data.indexOf(row), 1);
            }).catch(_ => {
            })
        },
        remove(row) {
            ElMessageBox.confirm('确定要删除该配置吗？', '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定',
                type: 'error',
            }).then(_ => {
                this.loading = true;
                axios.delete(`${this.$root.$getElasticDomain()}/cms/v1/mediation/${row.id}`).then(_ => {
                    this.data.splice(this.data.indexOf(row), 1);
                    this.loading = false;
                })
            }).catch(_ => {
            })
        },
    },
    mounted() {
        if (this.$route.query.domain) {
            this.init();
        } else {
            this.$router.push({query: {domain: 'elastic-test'}});
        }
    },
    watch: {
        $route() {
            if (this.$route.name === 'IAASdk' && this.$route.query.domain) {
                this.domain = this.$route.query.domain;
                this.form.product_id = this.$route.params.productId;
                this.init();
            }
        },
    }
}
</script>

<style scoped>
.sdk-tag {
    font-family: Menlo, Monaco, Consolas, monospace;
}

</style>
